import type { FaireProductEntity } from "../../entity_types/product";

export const p_32ux7j0t5z: FaireProductEntity = {
  token: "p_32ux7j0t5z",
  type: "product",
  name: "Jesus Heals",
  brandToken: "b_4q06brhpm1",
  brandName: "Harvest House Publishers Gift & Specialty Books",
  imageUrl:
    "https://cdn.faire.com/fastly/e95a95940222de7d6b1a3fa805f92c73af7645169c7c12cce0dc8c9c7058922c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8e3d2cebf347376edb26867f6bfa33c5a9b375d9efe65396373bca54a4cb3ebf.jpeg",
    "https://cdn.faire.com/fastly/73a381de2526b9570b6c807c211d9c825e3a3b08e57c774c0198d2c245466ebd.jpeg",
    "https://cdn.faire.com/fastly/23663f11bad75368b046ed9fd608287711b7544a0d092363d854172cbc3f2c65.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Buy 6 of any title and get the 7th free!\n\nGod Cares for Every Body\n \nYour family will love this unique board book! Using colorful, engaging artwork, Jesus Heals introduces little ones to different parts of the body through the healings Jesus performed, pointing to His ultimate miracle—healing our sin by His death on the cross.  \n \nChildren will delight in the beautiful illustrations and learn about basic human anatomy as they see how Jesus healed various body parts.\n \nYou will appreciate the artistic design, theologically sound content, and helping your little one understand that God cares for our physical bodies.\n  \n***\n \nBaby Believer primers are designed to grow with children, from early infancy through elementary school. In addition to basic Bible theology, Baby Believer board books are filled with quotations from the Bible, creeds, hymns, church fathers, and other articles of faith to help reinforce the content and provide intellectual handholds for older children who possess a greater capacity for learning and memorization.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:33.335Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
